/**
 * Lightweight module-level holder for the active householdId.
 *
 * Some services (notably unifiedRecipeService) are called from many places
 * without easy access to Redux. Rather than thread `householdId` through
 * every call site, the auth layer pushes the current value here whenever it
 * changes, and the services read it when computing Firestore paths.
 *
 * This is a *cache of the truth* — the canonical source remains
 * `state.auth.householdId`. Always update via setActiveHouseholdId.
 */

let activeHouseholdId: string | null = null;

export const setActiveHouseholdId = (householdId: string | null): void => {
  activeHouseholdId = householdId;
};

export const getActiveHouseholdId = (): string | null => activeHouseholdId;

export const clearActiveHouseholdId = (): void => {
  activeHouseholdId = null;
};
